import React, { FC } from "react";
import Button from "components/shared/Button";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import InputTemp from "components-new/InputTemp";
import styles from "./CreateDocument.module.sass";
import { IInitialUploadData } from "./CreateDocument";
import { useValidate } from "hooks/useValidate";

interface EditTemplateProps {
	nextStep: () => void;
	close: () => void;
	data: IInitialUploadData;
	setData: React.Dispatch<React.SetStateAction<IInitialUploadData>>;
}

const EditTemplate: FC<EditTemplateProps> = ({ nextStep, setData, data, close }) => {
	const changeData = ({ target }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		let { value: docxName } = target;
		docxName = docxName.replace(/^\s+/, "");
		setData((prevState) => ({ ...prevState, docxName }));
	};

	const { error, validate } = useValidate(data, ["docxName"], nextStep);

	return (
		<>
			<InputTemp
				value={data.docxName}
				error={!data.docxName && error}
				onChange={changeData}
				className={styles.input}
				label="Наименование документа"
				required
			/>
			{/*<InputTemp*/}
			{/*	className={styles.input}*/}
			{/*	type="select"*/}
			{/*	options={[{ id: 1, name: "1" }]}*/}
			{/*	field={"name"}*/}
			{/*	label="Тип документа"*/}
			{/*	required*/}
			{/*/>*/}
			<div className={styles.btns}>
				<Button className={styles.button} full variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
					Отменить
				</Button>
				<Button className={styles.button} full onClick={validate}>
					Готово
				</Button>
			</div>
		</>
	);
};

export default EditTemplate;
